<template>
  <v-container
    fluid
    fill-height
  >
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-row class="align-center justify-right">
              <v-col
                cols="6"
                md="3"
              >
                <search-field v-model="search" />
              </v-col>
              <v-spacer />
              <v-col
                cols="3"
                class="text-right"
              >
                <add-new-button
                  title="Add external document to your Document Register"
                  @click="uploadNewDocument"
                />
              </v-col>
            </v-row>

            <url-persisted-data-table
              :v-model="selectedRow"
              :headers="headers"
              :items="items"
              :loading="loading"
              :search.sync="search"
              :no-data-text="loadingOrNoDataText"
              default-sort-by="vaultDate"
              :default-sort-desc="true"
              :single-select="true"
              :class="{
                'hide-colgroup table-fixed': $vuetify.breakpoint.xs,
                'table-is-mobile': tableIsMobile
              }"
              @click:row="selectTableRow"
            >
              <template #[`item.jobId`]="{ item }">
                <doc-job-id
                  :job-id="item.jobId"
                  :job-name="item.jobName"
                />
              </template>

              <template #[`item.documentType`]="{item}">
                <document-type-label
                  :document-type="item.documentType"
                />
              </template>

              <template #[`item.name`]="{ item }">
                <div class="">
                  {{ item.shortName || item.name }}
                </div>
              </template>

              <template #[`item.clientName`]="{ item }">
                <client-name
                  :client="item.client"
                  :client-name="item.clientName"
                  :assigned-to-client="item.assignedToClient"
                />
              </template>

              <template #[`item.assignedToSort`]="{ item }">
                <people
                  :assigned-to="item.assignedTo"
                  :assigned-to-client="item.assignedToClient"
                  :assigned-to-me="item.assignedToMe"
                  :assigned-to-role="item.assignedToRole"
                  :non-client-roles-count="item.nonClientRolesCount"
                  :roles="item.roles"
                />
              </template>

              <template #[`item.signedDate`]="{ item }">
                <span class="text-no-wrap">
                  <span v-if="item.signed === 'Unsigned'">{{
                    item.status
                  }}</span>

                  <span v-else>{{ item.signedDate }}</span>
                </span>
              </template>

              <template #[`item.vaultDate`]="{ item }">
                {{ formatTimestamp(item.modified.seconds) }}
              </template>
              <template #[`body.append`]="{ isMobile }">
                <span v-show="false">{{ (tableIsMobile = isMobile) }}</span>
              </template>
            </url-persisted-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <vault-upload-dialog
      v-if="uploadFileDialog"
      @close="closeUploadFileDialog"
    />
  </v-container>
</template>

<script>
import DocJobId from '@/components/DocJobId.vue'
import VaultUploadDialog from '@/components/VaultUploadDialog.vue'
import AddNewButton from '@/components/AddNewButton'
import DocumentTypeLabel from '@/components/DocumentTypeLabel.vue'
import SearchField from '@/components/SearchField'
import UrlPersistedDataTable from '@/components/UrlPersistedDataTable.vue'

export default {
  name: 'DocumentRegister',
  components: {
    AddNewButton,
    DocJobId,
    DocumentTypeLabel,
    SearchField,
    VaultUploadDialog,
    UrlPersistedDataTable
  },
  data: function () {
    return {
      search: '',
      tableIsMobile: false,
      downloading: null,
      uploadFileDialog: false,
      selectedRow: null
    }
  },
  computed: {
    headers() {
      const headers = [
        {
          text: 'JobId',
          value: 'jobId',
          sortable: true,
          align: ' px-sm-only-3 pr-0 text-no-wrap',
          hidden: this.isIndividual || this.$vuetify.breakpoint.sm
        },
        {
          text: 'Document',
          value: 'name',
          filterable: true,
          sortable: true,
          align: ' px-sm-only-3 '
        },
        { text: 'Counterparty', value: 'counterpartyName', sortable: true, align: ' px-sm-only-3 ' },
        { text: 'Type', value: 'documentType', filterable: false, sortable: true, align: ' px-sm-only-3 ' },
        {
          text: 'Signed Date',
          value: 'signedDate',
          filterable: false,
          sortable: true,
          align: 'center px-sm-only-3 '
        },
        { text: 'Vault Date', value: 'vaultDate', filterable: false, sortable: true, align: 'px-sm-only-3 ' }
      ]

      return headers.filter((header) => !header.hidden)
    },
    items() {
      if (this.loading) {
        return []
      }
      return this.vaultDocuments
    },
    loading() {
      return this.vaultDocumentsLoading || this.counterpartyUsersLoading
    },
    loadingOrNoDataText() {
      return this.loading ? 'Loading items...' : 'No data.'
    }
  },
  beforeCreate() {
    this.dispatchActions([
      'get_vaultDocuments'
    ])

    this.mapStates([
      'vaultDocumentsLoading',
      'vaultDocuments'
    ])
    this.mapGetters(['isIndividual'])
  },
  methods: {
    uploadNewDocument() {
      this.uploadFileDialog = true
    },
    async selectTableRow(item, row) {
      this.$router.push({ query: this.$route.query, path: `/register/documents/${item.id}` }).catch(() => {})
      row.select(true)
    },
    closeUploadFileDialog() {
      this.uploadFileDialog = false
    },
    formatTimestamp(seconds) {
      let dateObj = new Date(1970, 0, 1) // Epoch
      dateObj.setSeconds(seconds)
      const month = dateObj.getMonth() + 1
      const year = dateObj.getFullYear()
      const date = dateObj.getDate()

      return `${month}/${date}/${year}`
    }
  }
}
</script>
<style>
tbody tr th {
  text-align: left;
}
</style>
